import { IGetAllPermissaoGrupoAcessoUseCase } from "../../../presentation/useCases/read/get_all_permissao_grupo_acesso_use_case";
import { PermissaoAcessoGrupoLista } from "../../models/permissao_acesso_grupo_lista";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetAllPermissaoGrupoAcessoUseCase
 */

export class GetAllPermissaoGrupoAcessoUseCase implements IGetAllPermissaoGrupoAcessoUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(
    idGrupoAcesso: number
  ): Promise<PermissaoAcessoGrupoLista[]> {
    return this.repository.getAllPermissaoGrupoAcesso(idGrupoAcesso);

  }
}
